import { journalEntries } from '@/utils/journalFeed';
import StepSection from './StepSection';

const trade = journalEntries[0];
const entry = Number(trade.entry);
const stopLoss = entry + 15;
const takeProfit = entry - 22;

const ticket = [
  {
    index: '01',
    label: 'Order Type',
    detail: 'Market execution · filled at price',
    value: 'MARKET',
    tone: 'default' as const,
  },
  {
    index: '02',
    label: 'Volume',
    detail: 'Fixed per the risk model',
    value: trade.volume,
    tone: 'default' as const,
  },
  {
    index: '03',
    label: 'Stop Loss',
    detail: 'Attached automatically on entry',
    value: stopLoss.toFixed(2),
    tone: 'loss' as const,
  },
  {
    index: '04',
    label: 'Take Profit',
    detail: 'Attached automatically on entry',
    value: takeProfit.toFixed(2),
    tone: 'profit' as const,
  },
];

const valueTone: Record<string, string> = {
  default: 'text-foreground-950',
  loss: 'text-loss-600',
  profit: 'text-profit-600',
};

function StepExecute() {
  return (
    <StepSection
      id="step-06"
      index="06"
      stage="execute"
      title="Execute Through MT5"
      subtitle="A confirmed setup is routed straight to the MT5 terminal."
      body="When the required conditions are satisfied, the order is opened at the calculated entry price — with volume, stop loss and take profit attached in the same action."
      reverse
    >
      <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
        <div className="flex items-center justify-between px-4 md:px-5 h-11 border-b border-background-200 bg-background-100">
          <span className="flex items-center gap-2 text-[11px] font-data tracking-widest text-foreground-700">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 breathe"></span>
            MT5 · ORDER ROUTED
          </span>
          <span className="text-[10px] font-data tracking-widest text-profit-600">FILLED</span>
        </div>

        <div className="flex items-end justify-between px-4 md:px-5 pt-4 pb-3">
          <div>
            <p className="text-[10px] font-data tracking-[0.22em] text-foreground-400">
              ENTRY FILL
            </p>
            <p className="mt-1.5 font-data text-[30px] md:text-[34px] font-semibold leading-none text-foreground-950">
              {entry.toFixed(2)}
            </p>
          </div>
          <div className="text-right">
            <p className="text-[10px] font-data tracking-[0.22em] text-foreground-400">
              ORDER SIDE
            </p>
            <p className="mt-1.5 font-data text-[15px] font-semibold leading-none text-foreground-950">
              {trade.side}
            </p>
          </div>
        </div>

        <div className="divide-y divide-background-200 border-t border-background-200">
          {ticket.map((row) => (
            <div key={row.index} className="flex items-center gap-3 px-4 md:px-5 py-3.5">
              <span className="w-5 shrink-0 font-data text-[11px] text-foreground-400">
                {row.index}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-[13px] font-semibold text-foreground-900 truncate">{row.label}</p>
                <p className="text-[11px] text-foreground-500 truncate">{row.detail}</p>
              </div>
              <span className={`shrink-0 font-data text-[13px] font-semibold ${valueTone[row.tone]}`}>
                {row.value}
              </span>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between border-t border-background-200 bg-background-100 px-4 md:px-5 py-3">
          <span className="font-data text-[10px] tracking-widest text-foreground-400">
            XAUUSD · {trade.date}
          </span>
          <span className="font-data text-[10px] tracking-widest text-foreground-500">
            STOP &amp; TARGET ATTACHED
          </span>
        </div>
      </div>
    </StepSection>
  );
}

export default StepExecute;